import numbro from "numbro";
import { handleActions } from "redux-actions";
import {
  getDateRanges,
  getRangeOptions,
  getRangeOptionsWithCustom,
  getSelectedRangeOptionWithCustom,
  getSelectedRangeOption,
  getPreviousFilterDates
} from "../../../../utils/date-range-options";
import {
  SET_LOADING,
  SET_DATES,
  SET_FILTERS_DIRTY,
  UPDATE_DATES,
  UPDATE_SITES,
  UPDATE_GROUP_BY,
  UPDATE_REVENUE_TYPE,
  UPDATE_LOCATIONS,
  FETCH_TABLE_DATA_SUCCESS,
  FETCH_CONVERSIONS_SUCCESS,
  FETCH_CONVERSIONS_FAILURE,
  FETCH_ALL_REVENUE_SUCCESS,
  FETCH_ALL_REVENUE_FAILURE,
  FETCH_FILTERS_SUCCESS,
  FETCH_FILTERS_EXCLUDE_SITES_SUCCESS,
  SET_TABLES_LOADING,
  UPDATE_CUSTOM_RANGE,
  SET_SECOND_LEVEL_FILTERS_LOADING,
  SET_THIRD_LEVEL_FILTERS_LOADING,
  SET_FOURTH_LEVEL_FILTERS_LOADING,
  UPDATE_SELECTED_FIRST_LEVEL_FILTERS,
  UPDATE_SELECTED_SECOND_LEVEL_FILTERS,
  UPDATE_SELECTED_THIRD_LEVEL_FILTERS,
  UPDATE_SELECTED_FOURTH_LEVEL_FILTERS,
  UPDATE_FILTERS_REQUEST,
  UPDATE_PREV_DATES
} from "./multiLocationSagas";

const initialState = {
  isLoading: true,
  currentUser: {},
  conversions: {
    tableInfo: {
      data: []
    }
  },
  allRevenue: {
    tableInfo: {
      data: []
    },
    titles: []
  },
  selectedRequestDates: {},
  selectedRequestPrevDates: {},
  selectedLevelFirst: {},
  selectedLevelSecond: {},
  selectedLevelThird: {},
  selectedLevelFourth: {},
  filtersDirty: false,
  secondLevelFiltersLoading: false,
  thirdLevelFiltersLoading: false,
  fourthLevelFiltersLoading: false,
  tablesLoading: false,
  groupBy: {},
  revenueType: {},
  availableFilters: {
    regions: {},
    objects: {},
    locations: {},
    level_1: {},
    level_2: {},
    level_3: {}
  },
  haveRequestError: false,
  requestError: {},
  selectedRangeOption: {},
  rangeOptions: []
};

function getAverages(totals, locations, currency = "", mantissa = 2) {
  let averages = {};
  if (Array.isArray(locations) && locations.length) {
    for (let total in totals) {
      let totalValue = totals[total].replace(currency, "");
      let average = numbro.unformat(totalValue) / locations.length;
      let formattedAverage = numbro(average).format({ thousandSeparated: true, mantissa });
      let formattedAverageWithCurrency = totals[total].replace(totalValue, formattedAverage);

      averages = {
        ...averages,
        [`${total}_average`]: formattedAverageWithCurrency
      };
    }
  }
  return averages;
}

export default handleActions(
  {
    [SET_LOADING]: (state, action) => ({
      ...state,
      isLoading: action.payload,
      haveRequestError: false
    }),
    [SET_TABLES_LOADING]: (state, action) => ({
      ...state,
      tablesLoading: action.payload
    }),
    [SET_FILTERS_DIRTY]: (state, action) => ({
      ...state,
      filtersDirty: action.payload
    }),
    [SET_SECOND_LEVEL_FILTERS_LOADING]: (state, action) => ({
      ...state,
      secondLevelFiltersLoading: action.payload
    }),
    [SET_THIRD_LEVEL_FILTERS_LOADING]: (state, action) => ({
      ...state,
      thirdLevelFiltersLoading: action.payload
    }),
    [SET_FOURTH_LEVEL_FILTERS_LOADING]: (state, action) => ({
      ...state,
      fourthLevelFiltersLoading: action.payload
    }),
    [FETCH_FILTERS_SUCCESS]: (state, action) => ({
      ...state,
      availableFilters: action.payload.filters || state.availableFilters,
      groupBy: action.payload.group_by,
      revenueType: action.payload.revenue_type,
      siteFiltersLoading: false,
      locationFiltersLoading: false,

      selectedLevelFirst: action.payload.filters.level_1,
      selectedLevelSecond: action.payload.filters.level_2,
      selectedLevelThird: action.payload.filters.level_3,
      selectedLevelFourth: action.payload.filters.level_4,

      filterTitles: action.payload.filters.filter_titles,
      filterLevels: action.payload.filters.filter_levels,
      filterParams: action.payload.filters.filter_params
    }),

    [UPDATE_FILTERS_REQUEST]: (state, action) => ({
      ...state,
      availableFilters: action.payload || state.availableFilters
    }),
    [UPDATE_GROUP_BY]: (state, action) => ({
      ...state,
      filtersDirty: true,
      groupBy: {
        ...state.groupBy,
        value: action.payload
      }
    }),
    [UPDATE_REVENUE_TYPE]: (state, action) => ({
      ...state,
      filtersDirty: true,
      revenueType: {
        ...state.revenueType,
        value: action.payload
      }
    }),
    [FETCH_FILTERS_EXCLUDE_SITES_SUCCESS]: (state, action) => ({
      ...state,
      availableFilters: action.payload.filters || state.availableFilters,
      locationFiltersLoading: false,
      selectedLocations: action.payload.filters.locations
    }),
    [SET_DATES]: (state, action) => ({
      ...state,
      selectedRequestDates: action.payload || state.selectedRequestDates
    }),
    [UPDATE_DATES]: (state, action) => ({
      ...state,
      selectedRequestDates: action.payload || state.selectedRequestDates,
      rangeOptions: getRangeOptionsWithCustom(state.rangeOptions, action),
      selectedRangeOption: getSelectedRangeOptionWithCustom(action),
      selectedRequestPrevDates: getPreviousFilterDates(
        action.payload.startDate,
        action.payload.endDate,
        state.currentUser.calendarStartDate
      ),
      filtersDirty: true
    }),
    [UPDATE_PREV_DATES]: (state, action) => ({
      ...state,
      selectedRequestPrevDates: action.payload || state.selectedRequestPrevDates,
      filtersDirty: true
    }),
    [UPDATE_SELECTED_FIRST_LEVEL_FILTERS]: (state, action) => ({
      ...state,
      selectedLevelFirst: action.payload || state.selectedLevelFirst,
      filtersDirty: true
    }),
    [UPDATE_SELECTED_SECOND_LEVEL_FILTERS]: (state, action) => ({
      ...state,
      selectedLevelSecond: action.payload || state.selectedLevelSecond,
      filtersDirty: true
    }),
    [UPDATE_SELECTED_THIRD_LEVEL_FILTERS]: (state, action) => ({
      ...state,
      selectedLevelThird: action.payload || state.selectedLevelThird,
      filtersDirty: true
    }),
    [UPDATE_SELECTED_FOURTH_LEVEL_FILTERS]: (state, action) => ({
      ...state,
      selectedLevelFourth: action.payload || state.selectedLevelFourth,
      filtersDirty: true
    }),
    [UPDATE_SITES]: (state, action) => ({
      ...state,
      selectedSites: action.payload || state.selectedSites,
      filtersDirty: true,
      siteFiltersLoading: false
    }),
    [UPDATE_LOCATIONS]: (state, action) => ({
      ...state,
      selectedLocations: action.payload || state.selectedLocations,
      filtersDirty: true,
      locationFiltersLoading: false
    }),
    [FETCH_TABLE_DATA_SUCCESS]: (state, action) => ({
      ...state,
      currentUser: action.payload || state.currentUser
    }),
    [FETCH_CONVERSIONS_SUCCESS]: (state, action) => {
      const { selectedLevelFourth: locations } = state;
      const { leads_total, app_total, show_total, enroll_total } = action.payload;
      const totals = {
        leads_total,
        app_total,
        show_total,
        enroll_total
      };
      return {
        ...state,
        conversions: { ...action.payload, ...getAverages(totals, locations, "") }
      };
    },
    [FETCH_CONVERSIONS_FAILURE]: (state, action) => ({
      ...state,
      requestError: action.error.response.data || state.requestError,
      isLoading: false,
      haveRequestError: true
    }),
    [FETCH_ALL_REVENUE_SUCCESS]: (state, action) => {
      const {
        selectedLevelFourth: locations,
        currentUser: { currencySymbol }
      } = state;
      const { revenue_total, membership_revenue_total } = action.payload;

      const totals = {
        revenue_total,
        membership_revenue_total
      };

      return {
        ...state,
        allRevenue: { ...action.payload, ...getAverages(totals, locations, currencySymbol) }
      };
    },
    [FETCH_ALL_REVENUE_FAILURE]: (state, action) => ({
      ...state,
      requestError: action.error.response.data || state.requestError,
      haveRequestError: true
    }),
    [SET_DATES]: (state, action) => {
      const { startDate, endDate } = action.payload;
      return {
        ...state,
        selectedRequestDates: action.payload,
        rangeOptions: getRangeOptions(action.payload.endDate, state.currentUser.calendarStartDate),
        selectedRangeOption: getSelectedRangeOption(action),
        selectedRequestPrevDates: getPreviousFilterDates(
          startDate,
          endDate,
          state.currentUser.calendarStartDate
        )
      };
    },
    [UPDATE_CUSTOM_RANGE]: (state, action) => {
      const { startDate, endDate } = getDateRanges(
        state.currentUser.calendarEndDate,
        action.payload,
        state.currentUser.calendarStartDate
      );

      return {
        ...state,
        selectedRangeOption: action.payload,
        selectedRequestDates: { startDate, endDate },
        selectedRequestPrevDates: getPreviousFilterDates(
          startDate,
          endDate,
          state.currentUser.calendarStartDate,
          action.payload.name
        ),
        filtersDirty: true,
        datesDirty: true
      };
    }
  },
  initialState
);
